import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Page, HeaderRow, HeroRow, Layout, MainCol, RightRail, SectionBlock } from '../../../Dashboard.styled';

export default function DashboardSkeleton() {
  return (
    <Page>
      <Layout>
        <MainCol>
          <HeaderRow>
            <Skeleton variant="text" width={220} />
            <Skeleton variant="rectangular" width={40} height={36} sx={{ borderRadius: '999px' }} />
          </HeaderRow>
          <HeroRow>
            <Skeleton variant="rectangular" width={300} height={90} sx={{ borderRadius: '12px' }} />
            <div style={{ flex: 1 }}>
              <Skeleton variant="text" width={140} />
              <Skeleton variant="text" width="60%" sx={{ fontSize: '30px' }} />
              <Skeleton variant="text" width={260} />
              <Skeleton
                variant="rectangular"
                width={190}
                height={44}
                sx={{ marginTop: '16px', borderRadius: '999px' }}
              />
            </div>
          </HeroRow>
          <SectionBlock>
            <Skeleton variant="text" width={160} />
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                gap: 14,
                marginTop: 12,
              }}
            >
              {[0, 1, 2].map(key => (
                <Skeleton key={key} variant="rectangular" height={220} sx={{ borderRadius: '14px' }} />
              ))}
            </div>
            <Skeleton variant="text" width={280} sx={{ marginTop: '28px' }} />
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                gap: 12,
                marginTop: 12,
              }}
            >
              {[0, 1, 2, 3].map(key => (
                <Skeleton key={key} variant="rectangular" height={80} sx={{ borderRadius: '12px' }} />
              ))}
            </div>
          </SectionBlock>
        </MainCol>
        {/* Noticias oculto por ahora; reactivar junto con el rail de index.tsx
        <RightRail>
          <Skeleton variant="text" width={100} />
          <Skeleton variant="rectangular" height={220} sx={{ marginTop: '12px', borderRadius: '14px' }} />
          <Skeleton variant="rectangular" height={120} sx={{ marginTop: '12px', borderRadius: '14px' }} />
        </RightRail> */}
      </Layout>
    </Page>
  );
}
